import { CHAT_VERSION } from './version';
export var Environments;
(function (Environments) {
  Environments['DEV'] = 'api-dev.highmark.com';
  Environments['TEST'] = 'api-qa.highmark.com';
  Environments['UAT'] = 'api-test.highmark.com';
  Environments['PROD'] = 'api.highmark.com';
})(Environments || (Environments = {}));
export class ChatConfig {
  constructor(env) {
    this.version = CHAT_VERSION;
    this.environment = env;
  }
}
//# sourceMappingURL=chat-config.js.map
